<div class="wrapper">
  @if (buttonKeys.length > 1) {
    <div class="table-btn-group">
      @for (key of buttonKeys; track $index) {
        <button
          mat-mini-fab
          color="accent"
          class="table-btn"
          [class.gray-filter]="!isDataExists"
          (click)="handleModalButtonClick(key)"
        >
          <mat-icon
            [class]="getClassIcon(key)"
          >
            {{ getClassIcon(key) }}
          </mat-icon>
        </button>
      }
    </div>
  } @else {
    @if (columnParam.key === 'telegram') {
      <button
        mat-mini-fab
        color="accent"
        matBadgeSize="small"
        class="table-btn"
        [class.gray-filter]="!isDataExists"
        [matBadge]="0"
        (click)="handleModalButtonClick()"
      >
        <mat-icon
          [class]="[
            iconName,
            iconName === 'info_outline' ? 'icon' : ''
          ]"
        >
          {{ iconName }}
        </mat-icon>
      </button>
    } @else {
      <button
        mat-mini-fab
        color="accent"
        class="table-btn"
        [matTooltip]="getTooltip(columnParam.key)"
        [class.gray-filter]="!isDataExists"
        (click)="handleModalButtonClick()"
      >
        <mat-icon
          [class]="[
            iconName,
            iconName === 'info_outline' ? 'icon' : ''
          ]"
        >
          {{ iconName }}
        </mat-icon>
      </button>
    }
  }
</div>
